module.exports = __webpack_public_path__ + "media/images/phone-icon-3c9cacfeb7a8dfc6816f4183fb6a6f66.png";